import { Button } from '@library/components/buttons';
import { classNames } from '@library/utils';

export type InputIconPositions = 'left-2' | 'right-2';

export interface InputIconWrapperProps {
  children: React.ReactNode;
  className?: string;
  hoverEnabled?: boolean;
  icon: string;
  iconClassName?: string;
  onIconClick?: () => void;
  position?: 'left' | 'right';
  disabled?: boolean;
}

export const InputIconWrapper = ({
  children,
  className = '',
  hoverEnabled = false,
  icon,
  iconClassName = '',
  onIconClick = undefined,
  position = 'left',
  disabled = false
}: InputIconWrapperProps) => {
  const isImageUrl = /\.(svg|png|jpg)$/.test(icon); // Check if the icon prop is image or text
  const textIconStyle = !isImageUrl
    ? 'bg-soFresh-140 text-soClean-130 font-heebo rounded pt-0.5 text-sm antialiased'
    : '';

  return (
    <div className={classNames('relative', className)}>
      <Button
        className={classNames(
          'absolute top-1/2 flex h-6 w-6 items-center justify-center',
          position === 'left' ? 'left-2' : 'right-2',
          hoverEnabled ? 'hover:bg-stankonia-100' : '',
          onIconClick ? 'cursor-pointer' : 'cursor-default',
          textIconStyle,
          iconClassName
        )}
        onClick={onIconClick}
        disabled={disabled}
      >
        {isImageUrl ? <img src={icon} alt="icon" /> : icon}
      </Button>
      {children}
    </div>
  );
};
